export default __webpack_public_path__ + "static/media/location2.98a685ea.svg";